export default __webpack_public_path__ + "static/media/SAICE-Connect-gold.763a4351.png";